export enum ATHFormatOfTExtFileEnum {
  'ACB' = 1,
  'Saambou',
  'Balance',
  'SABA',
  'QmAdmin',
  'Comma Delimited',
  'ACB Rej/Redirected',
  'NedBank',
  'DBREQ',
  'RESPONSE',
  'DBRESP',
  'NADREQ',
  'EDOREQ',
  'EDORESP',
  'NADRESP',
  'NADRCL',
  'NDISPUTE',
  'VET',
  'NADRCRSP',
  'MCT',
  'Electronic Transfer',
  'CollectionDebitOrder',
  'EFT REPORT',
  'EFT UNPAID',
  'SASSA',
  'SWIFT',
  'DROUT',
  'SECREQUEST',
  'SECRESPONS',
  'RTOUT'
}

export namespace ATHFormatOfTExtFileEnum {
  export function values() {
    return Object.keys(ATHFormatOfTExtFileEnum).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
